/**
 * TrackCursorLine — 진단 화면의 "지금" 세로 점 열.
 *
 * 지속음 트랙의 손잡이 자리(시안 `882:7938`)와 노래 곡선의 플레이헤드(`PitchTraceGraph`,
 * 흐르는 축)가 같이 쓴다. 점 간격·굵기가 여기 한 곳에만 적혀 있어야 두 화면의 "지금"
 * 마커가 같은 리듬으로 보인다. 자리(`at`)는 프롭이다 — 시안이 화면마다 다른 값을 준다.
 */
interface TrackCursorLineProps {
  /** 트랙 폭 대비 가로 위치(0..1). */
  at: number;
  /** 테스트가 이 선을 집는 이름. 화면마다 달라서 호출자가 준다. */
  testId: string;
  /**
   * 위아래로 페이드를 넣을 때, 선이 온전히 보이는 반폭(%). 지속음은 손잡이가 닿을 수
   * 있는 구간까지만 선을 보여준다. 안 주면 위아래 끝까지 그대로 그린다.
   */
  solidHalfPct?: number;
}

/**
 * 점 열이다, 대시가 아니다. 곡선 화면의 축이 반음마다 점을 찍던 동안에는 세로 점선이
 * 그 점들과 같은 무게로 읽혀 어느 쪽이 "지금"인지 안 갈렸다 — 축의 점을 걷고 이 선만
 * 점으로 남기면, 화면에서 점을 쓰는 곳은 움직이는 이 자리 하나뿐이다.
 */
export const CURSOR_DOTS = `radial-gradient(circle, hsl(var(--border)) 1.5px, transparent 1.75px)`;

/** 점 타일의 크기 — 가로는 선의 폭, 세로가 점 간격이다. 두 화면의 스펙이 같이 쓴다. */
export const CURSOR_DOT_SIZE = '6px 12px';

export const TrackCursorLine = ({
  at,
  testId,
  solidHalfPct,
}: TrackCursorLineProps) => {
  const mask =
    solidHalfPct == null
      ? undefined
      : `linear-gradient(to bottom, transparent, #000 ${50 - solidHalfPct}%, #000 ${50 + solidHalfPct}%, transparent)`;

  return (
    <div
      data-testid={testId}
      aria-hidden="true"
      className="absolute inset-y-0 w-[6px] -translate-x-1/2"
      style={{
        left: `${at * 100}%`,
        backgroundImage: CURSOR_DOTS,
        backgroundSize: CURSOR_DOT_SIZE,
        backgroundPosition: 'center',
        maskImage: mask,
        WebkitMaskImage: mask,
      }}
    />
  );
};
